var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 40,
    viewBox: "0 0 25 40",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.079 20.3945H18.4211C18.0577 20.3945 17.7632 20.6891 17.7632 21.0524C17.7632 21.4158 18.0577 21.7103 18.4211 21.7103V24.9998C18.0577 24.9998 17.7632 25.2943 17.7632 25.6577C17.7632 26.021 18.0577 26.3156 18.4211 26.3156H19.079C19.2535 26.3157 19.4209 26.2464 19.5443 26.123C19.6677 25.9996 19.737 25.8322 19.7369 25.6577V21.0524C19.737 20.8779 19.6677 20.7105 19.5443 20.5871C19.4209 20.4637 19.2535 20.3944 19.079 20.3945Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23687 11.8423H11.1842C11.3588 11.8424 11.5262 11.7731 11.6496 11.6497C11.773 11.5263 11.8422 11.3589 11.8421 11.1844V7.237C11.8422 7.06248 11.773 6.89508 11.6496 6.77168C11.5262 6.64828 11.3588 6.579 11.1842 6.5791H9.86845C8.05261 6.58124 6.58111 8.05273 6.57898 9.86858V11.1844C6.57888 11.3589 6.64816 11.5263 6.77156 11.6497C6.89496 11.7731 7.06236 11.8424 7.23687 11.8423ZM7.89477 9.86858C7.89596 8.77903 8.77891 7.89608 9.86845 7.89489H10.5263V10.5265H7.89477V9.86858Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8158 11.8423H17.7632C17.9377 11.8424 18.1051 11.7731 18.2285 11.6497C18.3519 11.5263 18.4212 11.3589 18.4211 11.1844V9.86858C18.4189 8.05273 16.9474 6.58124 15.1316 6.5791H13.8158C13.6413 6.579 13.4739 6.64828 13.3505 6.77168C13.2271 6.89508 13.1578 7.06248 13.1579 7.237V11.1844C13.1578 11.3589 13.2271 11.5263 13.3505 11.6497C13.4739 11.7731 13.6413 11.8424 13.8158 11.8423ZM14.4737 7.89489H15.1316C16.2211 7.89608 17.1041 8.77903 17.1053 9.86858V10.5265H14.4737V7.89489Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8421 17.7625V13.8151C11.8422 13.6406 11.773 13.4732 11.6496 13.3498C11.5262 13.2264 11.3588 13.1571 11.1842 13.1572H7.23687C7.06236 13.1571 6.89496 13.2264 6.77156 13.3498C6.64816 13.4732 6.57888 13.6406 6.57898 13.8151V17.7625C6.57888 17.937 6.64816 18.1044 6.77156 18.2278C6.89496 18.3512 7.06236 18.4205 7.23687 18.4204H11.1842C11.3588 18.4205 11.5262 18.3512 11.6496 18.2278C11.773 18.1044 11.8422 17.937 11.8421 17.7625ZM10.5263 17.1046H7.89477V14.473H10.5263V17.1046Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8158 18.4204H17.7632C17.9377 18.4205 18.1051 18.3512 18.2285 18.2278C18.3519 18.1044 18.4212 17.937 18.4211 17.7625V13.8151C18.4212 13.6406 18.3519 13.4732 18.2285 13.3498C18.1051 13.2264 17.9377 13.1571 17.7632 13.1572H13.8158C13.6413 13.1571 13.4739 13.2264 13.3505 13.3498C13.2271 13.4732 13.1578 13.6406 13.1579 13.8151V17.7625C13.1578 17.937 13.2271 18.1044 13.3505 18.2278C13.4739 18.3512 13.6413 18.4205 13.8158 18.4204ZM14.4737 14.473H17.1053V17.1046H14.4737V14.473Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1316 21.7109H9.86847C9.69395 21.7108 9.52655 21.7801 9.40315 21.9035C9.27975 22.0269 9.21047 22.1943 9.21057 22.3688V23.6846C9.21057 24.048 9.50512 24.3425 9.86847 24.3425C10.2318 24.3425 10.5264 24.048 10.5264 23.6846V23.0267H14.4737V23.6846C14.4737 24.048 14.7683 24.3425 15.1316 24.3425C15.495 24.3425 15.7895 24.048 15.7895 23.6846V22.3688C15.7896 22.1943 15.7203 22.0269 15.5969 21.9035C15.4735 21.7801 15.3061 21.7108 15.1316 21.7109Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28947 39.4737H24.3421C24.5166 39.4738 24.684 39.4045 24.8074 39.2811C24.9308 39.1577 25.0001 38.9903 25 38.8158V0.657895C25.0001 0.483379 24.9308 0.315982 24.8074 0.192581C24.684 0.06918 24.5166 -0.000101196 24.3421 1.10947e-07H0.657895C0.483379 -0.000101196 0.315982 0.06918 0.192581 0.192581C0.06918 0.315982 -0.000101196 0.483379 1.10947e-07 0.657895V38.8158C-0.000101196 38.9903 0.06918 39.1577 0.192581 39.2811C0.315982 39.4045 0.483379 39.4738 0.657895 39.4737H3.28947ZM1.31579 3.94737H2.63158V38.1579H1.31579V3.94737ZM3.94737 3.94737H21.0526V38.1579H3.94737V3.94737ZM23.6842 38.1579H22.3684V3.94737H23.6842V38.1579ZM1.31579 1.31579H23.6842V2.63158H1.31579V1.31579Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.7632,
    y1: 20.3945,
    x2: 21.3158,
    y2: 21.5787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6.57898,
    y1: 6.5791,
    x2: 11.8421,
    y2: 11.8423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.1579,
    y1: 6.5791,
    x2: 18.4211,
    y2: 11.8423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 6.57898,
    y1: 13.1572,
    x2: 11.8421,
    y2: 18.4204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 13.1579,
    y1: 13.1572,
    x2: 18.4211,
    y2: 18.4204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 9.21057,
    y1: 21.7109,
    x2: 11.0255,
    y2: 26.2481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 0,
    y1: 0,
    x2: 35.686,
    y2: 22.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoor);
export default __webpack_public_path__ + "static/media/icon-door.d828e7cf81ae8b58603689fdaaa5e921.svg";
export { ForwardRef as ReactComponent };